module.exports = __webpack_public_path__ + "files/c289ff49ec1e851a363462905ea1a0ba.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-8.png
// module id = 505
// module chunks = 76